import { useSyncExternalStore } from "react";

const mediaQuery: MediaQueryList | undefined =
  typeof window !== "undefined" && typeof window.matchMedia === "function"
    ? window.matchMedia("(prefers-reduced-motion: reduce)")
    : undefined;

const subscribe = (onChange: () => void): (() => void) => {
  const query = mediaQuery;
  if (!query) return () => {};

  if (typeof query.addEventListener === "function") {
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }

  // Older Safari exposes only the legacy MediaQueryList API.
  query.addListener(onChange);
  return () => query.removeListener(onChange);
};

const getSnapshot = (): boolean => mediaQuery?.matches ?? false;
const getServerSnapshot = (): boolean => false;

/** Reads the OS motion preference before first paint and subscribes to live changes. */
export const usePrefersReducedMotion = (): boolean =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
